<template>
  <picture>
    <source :srcset="sourceSrcset">
    <img :srcset="imgSrcset" :alt="alt">
    <slot>
    </slot>
  </picture>
</template>

<script>
  import { resizeUrl } from '@/filters'

  export default {
    props: {
      alt: String,
      supportsRetina: {
        type: Boolean,
        defualt: true
      },
      image: {
        type: String,
        required: true
      },
      width: Number,
      height: Number,
      fitMode: {
        type: String,
        default: 'crop',
        validator (value) {
          return ['max', 'pad', 'crop', 'stretch', 'carve']
        }
      }
    },

    computed: {
      dir () {
        if (this.image && (this.image[0] === '/' || /(http(s?)):\/\//i.test(this.image))) {
          return ''
        } else {
          return '/static/images/'
        }
      },

      imgSrcset () {
        if (this.dir.length) {
          return `${this.dir}${this.image}`
        }
        return resizeUrl(this.image, { width: this.width, height: this.height, mode: this.mode || 'crop' })
      },

      imgRetinaSrcset () {
        if (this.dir.length) {
          return `${this.dir}${this.retinaImage}`
        }
        return resizeUrl(this.image, { width: this.width * 2, height: this.height * 2, mode: this.mode || 'crop' })
      },

      sourceSrcset () {
        return `${this.imgSrcset}, ${this.imgRetinaSrcset} 2x`
      },

      retinaImage () {
        let parts = this.image.split('.')
        if (parts.length > 1) {
          parts[parts.length - 2] = parts[parts.length - 2] + '@2x'
          return parts.join('.')
        } else {
          throw Error(`illigal image name ${this.image}`)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Picture.vue?6077e552